import React, { useState, useEffect } from 'react';
import { getTextFileUrl } from '../../actions/textsActions';
import { S3_PREFIX_EXAM_ATTACHMENTS } from '../../actions/constants';

/**
 * Componente para renderizar un texto individual con URL asíncrona
 */
function TextItem({ text }) {
  const [textUrl, setTextUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUrl = async () => {
      if (text.link) {
        setTextUrl(text.link);
        setLoading(false);
        return;
      }

      if (!text.file) {
        setLoading(false);
        return;
      }

      try {
        const url = await getTextFileUrl(text.id, text.file, S3_PREFIX_EXAM_ATTACHMENTS);
        setTextUrl(url);
      } catch (error) {
        console.error('Error obteniendo URL del texto:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUrl();
  }, [text]);

  if (loading) {
    return (
      <li key={text.id}>
        <span>{text.title} <small>(cargando...)</small></span>
      </li>
    );
  }

  if (!textUrl) {
    return (
      <li key={text.id}>
        <span>{text.title} <small className="text-muted">(sin archivo)</small></span>
      </li>
    );
  }

  return (
    <li key={text.id}>
      <a href={textUrl} target="_blank" rel="noopener noreferrer">{text.title}</a>
    </li>
  );
}

/**
 * Función para renderizar los adjuntos asociados a una pregunta.
 *
 * @export TestTextsList
 * @param {*} props : Los adjuntos de la pregunta (texts).
 * @returns El componente para mostrar la lista de adjuntos.
 */
export default function TestTextsList(props) {
  return (
    <div>
      <h4><strong>Contenidos adjuntos:</strong></h4>
      <ul>
        {props.texts.map((text) => (
          <TextItem key={text.id} text={text} />
        ))}
      </ul>
    </div>
  );
}
